var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 47",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "support_svg__a",
    d: "M0 .056h49.924v46.148H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.859 31.624.065-.026v12.034a2.624 2.624 0 0 1-4.48 1.856l-6.016-6.017H7.872A7.872 7.872 0 0 1 0 31.598V7.981A7.872 7.872 0 0 1 7.872.108h34.114a7.872 7.872 0 0 1 7.873 7.873v23.643Z",
    fill: "#394A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.05 23.726a3.936 3.936 0 1 1 0-7.873 3.936 3.936 0 0 1 0 7.873m-13.12 0a3.936 3.936 0 1 1 0-7.873 3.936 3.936 0 0 1 0 7.873m-13.121 0a3.936 3.936 0 1 1 0-7.873 3.936 3.936 0 0 1 0 7.873",
    fill: "#5298F4"
  }))));
};

export default SvgSupport;